const { useState } = require("react");

const useErrorHandler = () => {
  const [error, setError] = useState({});
  const [focusedField, setFocusedField] = useState("");
  var hasErrorFlag = false

  const addError = (newError, focus = true) => {
    let fieldToFocus
    if(!hasErrorFlag)
    {
      fieldToFocus = Object.keys(newError)[0]
      setFocusedField(fieldToFocus)
    }
    if(fieldToFocus && focus)
    {
      const element = document.getElementById(fieldToFocus);
      if (element) {
        element.focus();
        element.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }

    hasErrorFlag = true
    setError((prev) => ({
      ...prev,
      ...newError,
    }));
  };

  const clearError = () => {
    hasErrorFlag = false
    setError({});
    setFocusedField("")
  };

  const hasError = () => {
    return hasErrorFlag;
  };

  return { addError, clearError, error, hasError, focusedField };
};

export default useErrorHandler;
